import { WalletTabType, WalletTransactionSourceType, WalletTransactionStatus } from '@/src/types/wallet'

/**
 * Available wallet tabs
 */
export const WALLET_TABS: WalletTabType[] = ['EARNED', 'USED', 'REFUND']

/**
 * Map source type codes to display labels
 */
export const SOURCE_TYPE_LABELS: Record<WalletTransactionSourceType | string, string> = {
    F: 'Flight',
    H: 'Hotel',
    FPH: 'Flights and Hotel',
    FC: 'Flyin Cash',
    Qitaf: 'Qitaf',
    WCB: 'Cashback',
    BOOKING: 'Booking',
    REDEEM: 'Redeem',
    REFERRAL_BONUS: 'Referral bonus'
}

/**
 * Icon types for transaction source types
 */
export type TransactionIconType = 'refresh' | 'gift' | 'card'

export const SOURCE_TYPE_ICON_TYPES: Record<WalletTransactionSourceType | string, TransactionIconType> = {
    F: 'card',
    H: 'card',
    FPH: 'card',
    FC: 'gift',
    Qitaf: 'gift',
    WCB: 'gift',
    BOOKING: 'card',
    REDEEM: 'card',
    REFERRAL_BONUS: 'gift'
}

/**
 * Map transaction status to display labels
 */
export const TRANSACTION_STATUS_LABELS: Record<WalletTransactionStatus, string> = {
    active: 'Active',
    inactive: 'Inactive',
    'in active': 'Inactive'
}

/**
 * Source types that should show reference number
 */
export const SOURCES_WITH_REFERENCE: WalletTransactionSourceType[] = ['F', 'H', 'WCB', 'BOOKING', 'REDEEM']
